import { getUserTransactions } from "../../routes/transactions";

export const REDUX_SET_USER_TRANSACTIONS = "REDUX_SET_USER_TRANSACTIONS";

export function setUserTransactions() {
  return async (dispatch) => {
    try {
      const response = await getUserTransactions();
      dispatch({
        type: REDUX_SET_USER_TRANSACTIONS,
        transactions: response.data?.data || [],
      });
    } catch (e) {
      console.error(e);
    }
  };
}
